// Copyright (c) StrangeBee 2024

import { QuerySelector } from 'thehive-sdk';

export const computeListSelector = (): QuerySelector => ({
    head: [{ name: 'listTag' }, { name: 'freetags' }],
    extraData: ['usage'],
    name: 'get-all-custom-tags',
    sort: ['+predicate'],
});
